exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "section.svelte-1lbnbh0{cursor:pointer}", ""]);
